/* eslint-disable no-unused-vars */
import React from "react";
import { Row, Col, Card } from "antd";

import { ReactComponent as Location } from "../../../assests/images/credit-loc.svg";
import { ReactComponent as Mail } from "../../../assests/images/credit-mail.svg";
import { ReactComponent as Phone } from "../../../assests/images/credit-phone.svg";
import { useParams } from "react-router-dom";

function AddressCard({
  setReturnAddressDrawer,
  // cardDesing,
  capitalize,
  senderAddress,
}) {
  const {
    senderName,
    senderAddressLine1,
    returnName,
    returnAddressLine1,
    senderMobileNumber,
    returnMobileNumber,
    senderEmail,
    returnEmail,
    senderPincode,
  } = senderAddress;

  const params = useParams();

  return (
    <div className="mt-1">
      <Card
        size="small"
        title={
          <>
            <div className="space-between">
              <span>Return Address</span>
              {/* {!params?.id && (
                <span
                  className="iconStyles, pointer"
                  onClick={() => setReturnAddressDrawer(true)}
                >
                  Change
                </span>
              )} */}
            </div>
          </>
        }
        className="cardDesing"
        // style={cardDesing}
      >
        <p className="iconStyles">{capitalize(senderName || returnName)}</p>
        <Row>
          <Col lg={2} className="flex-start">
            <Location height={30} />
          </Col>
          <Col lg={22}>
            <span>{capitalize(senderAddressLine1 || returnAddressLine1)}</span>
            <p>Pincode: {senderPincode}</p>
          </Col>
        </Row>
        {(senderMobileNumber || returnMobileNumber) && (
          <Row>
            <Col lg={2} className="flex-start ">
              <Phone height={20} />
            </Col>
            <Col lg={22}>
              <p>{senderMobileNumber || returnMobileNumber}</p>
            </Col>
          </Row>
        )}
        {(senderEmail || returnEmail) && (
          <Row>
            <Col lg={2} className="flex-start">
              <Mail height={20} />
            </Col>
            <Col lg={22}>
              <p style={{ wordWrap: "break-word", whiteSpace: "normal" }}>
                {senderEmail || returnEmail}
              </p>
            </Col>
          </Row>
        )}
      </Card>
    </div>
  );
}

export default AddressCard;
